/** Position the start of the form slightly above the viewport center. */
export function scrollFormIntoView(element: HTMLElement | null) {
    if (!element?.isConnected) return;

    const previousMargin = element.style.scrollMarginTop;
    element.style.scrollMarginTop =
        Math.round(
            (element.ownerDocument.defaultView?.innerHeight ?? 0) * 0.4,
        ) + 'px';

    try {
        element.scrollIntoView({ behavior: 'instant', block: 'start' });
    } finally {
        element.style.scrollMarginTop = previousMargin;
    }
}
